import React from "react";
import { StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { StatusConfig } from "./types";

type StatusBarProps = {
  config: StatusConfig;
  compact?: boolean;
};

export function StatusBar({ config, compact = false }: StatusBarProps) {
  return (
    <LinearGradient
      colors={config.gradient}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={[styles.statusBar, compact && styles.statusBarCompact]}
    />
  );
}

const styles = StyleSheet.create({
  statusBar: {
    height: 3,
    opacity: 0.8,
  },
  statusBarCompact: {
    height: 2,
  },
});
